<list-view [liste]="geographieService.listeIata" *ngIf="geographieService.listeIata"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>